"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMINS_CAN_EDIT_ANY_OTHER_ADMIN_MESSAGES = void 0;
exports.ADMINS_CAN_EDIT_ANY_OTHER_ADMIN_MESSAGES = true;
